import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=4d6b06d5"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=4d6b06d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports